module.exports = __webpack_public_path__ + "static/media/happynourlogo.5e42be86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Header/happynourlogo.jpg
// module id = 452
// module chunks = 0